import { Button, Grid } from "@mui/material";

const SampleFileDowload = ({ type = 1 }: { type?: number }) => {
  //file type 1 for number file, 2 for personalize, 3 for template file download
  const handleDownload = (url: any, fileName: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Grid container justifyContent={"center"} spacing={2}>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={6}>
        <Button
          variant="outlined"
          onClick={() => {
            handleDownload(
              require(type === 1
                ? "../../assets/sample_files/sample_for_number_file.xlsx"
                : type === 2
                ? "../../assets/sample_files/sample_for_personalized_message.xlsx"
                : "../../assets/sample_files/sample_for_templated_message.xlsx"),
              type === 1 ? "sample_for_number_file.xlsx" : type === 2 ? "sample_for_personalized_file.xlsx" : "sample_for_template_file.xlsx"
            );
          }}
          // href={require('../../assets/sample_files/sample_for_number_file.xlsx')}
          startIcon={<img src={"https://dsuabgmmtxmj1.cloudfront.net/common/excel_icon2.png"} height={"40"} width={"40"} alt="" />}
        >
          Sample_Excel
        </Button>
      </Grid>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={6}>
        <Button
          variant="outlined"
          onClick={() => {
            handleDownload(
              require(type === 1
                ? "../../assets/sample_files/sample_for_number_file.csv"
                : type === 2
                ? "../../assets/sample_files/sample_for_personalized_message.csv"
                : "../../assets/sample_files/sample_for_templated_message.csv"),
              type === 1 ? "sample_for_number_file.csv" : type === 2 ? "sample_for_personalized_file.csv" : "sample_for_template_file.csv"
            );
          }}
          // href={require('../../assets/sample_files/sample_for_number_file.csv')}
          startIcon={<img src={"https://cdn-icons-png.flaticon.com/128/8242/8242984.png"} height={"40"} width={"40"} alt="" />}
        >
          Sample_CSV
        </Button>
      </Grid>
    </Grid>
  );
};

export default SampleFileDowload;
